<template>
  <dt-notice
    kind="warning"
    class="d-wmx100p d-mt24"
    hide-close
    title="Use DtStack in favor of Flex CSS Utilities"
  >
    Use the
    <dt-link to="/components/stack" kind="muted">
      DtStack
    </dt-link>
    component for most Flex-based layout implementations. View
    <dt-link to="/about/whats-new/posts/2025-12-2" kind="muted">
      Migrating from Flex CSS Utilities to DtStack
    </dt-link>
    for more details.
  </dt-notice>
</template>

<script>
export default {
  name: 'FlexStackNotice',
};
</script>
